import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useLocation, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createAsset } from "../../redux/actions/asset.actions";
import ListErrors from "../../components/ListErrors";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import {
  loadAssetEditPage,
  unloadAssetEditPage,
  updateAsset
} from "../../redux/actions/asset.actions";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";

const AssetSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, i18n.t("asset.form_name_invalid_error"))
    .required(i18n.t("asset.form_name_required_error")),
  site: Yup.string().required(i18n.t("asset.form_site_required_error"))
});

export default () => {
  let { key } = useParams();
  const [image, setImage] = useState(null);
  const dispatch = useDispatch();
  const asset = useSelector(state => state.asset);

  useEffect(() => {
    dispatch(loadAssetEditPage(key));
    return () => dispatch(unloadAssetEditPage());
  }, [key]);

  const handleSubmit = (name, encoding, hash, site, image_source, phone) =>
    dispatch(updateAsset(key, name, encoding, hash, site, image_source, phone));
  if (!asset.sites || !asset.asset) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"assets"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }

  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"assets"} />
          <div id="content">
            <Header />
            <div className="content-wrap content-narrow">
              <div className="box-header">
                <Link
                  className="header-button"
                  to={`/assets/${asset.asset.key}`}
                >
                  {t("common.back")}
                </Link>
                <h2>{t("asset.update_title")}</h2>
              </div>
              <Formik
                initialValues={{
                  name: asset.asset.name,
                  encoding: asset.asset.encoding || "",
                  hash: asset.asset.hash || "",
                  site: asset.asset.site,
                  phone: asset.asset.phone
                }}
                validationSchema={AssetSchema}
                onSubmit={(payload, { setSubmitting }) => {
                  handleSubmit(
                    payload.name,
                    payload.encoding,
                    payload.hash,
                    payload.site,
                    image,
                    payload.phone
                  );
                  setSubmitting(false);
                }}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <div className={`form-item`}>
                      <label htmlFor="name">{t("asset.label_name")}</label>
                      <Field
                        name="name"
                        type="text"
                        placeholder={t("asset.input_name_placeholder")}
                      />
                      <ErrorMessage
                        name="name"
                        className="error-message"
                        component="div"
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="name">{t("asset.label_phone")}</label>
                      <Field
                        name="phone"
                        type="text"
                        placeholder="+61 54561111"
                      />
                      <ErrorMessage
                        name="phone"
                        className="error-message"
                        component="div"
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="file">{t("asset.label_image")}</label>
                      <Field
                        name="file"
                        type="file"
                        accept="image/*"
                        onChange={e => setImage(e.target.files[0])}
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="encoding">
                        {t("asset.label_encoding")}
                      </label>
                      <Field
                        name="encoding"
                        component="textarea"
                        placeholder=""
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="hash">{t("asset.label_hash")}</label>
                      <Field name="hash" type="text" placeholder="" />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="name">{t("common.site")}</label>
                      <Field as="select" name="site">
                        <option key={""} value={""}>
                          {t("common.option_select_site")}
                        </option>
                        {asset.sites.map(item => {
                          return (
                            <option key={item.key} value={item.key}>
                              {item.name}
                            </option>
                          );
                        })}
                      </Field>
                      <ErrorMessage
                        name="site"
                        className="error-message"
                        component="div"
                      />
                    </div>
                    <ListErrors errors={asset.errors} />
                    <div className="form-item">
                      <button type="submit" disabled={isSubmitting}>
                        {isSubmitting
                          ? t("system.submitting_feeback")
                          : t("system.update_button")}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
};
